<template>
  <b-container fluid>
    <!-- <b-btn class="create-button" v-b-modal.modal1>Create Session</b-btn> -->
     <b-card>
      <b-row class="my-1">
        <b-col sm="6">
          <b-input-group class="mt-3">
            <b-input-group-prepend is-text>
              Search Market Session:&nbsp;&nbsp;
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>
            <b-form-input v-model="filter" sm="3"></b-form-input>
            <b-button v-if="filter" v-on:click="clearAll" variant="light"><b-icon aria-hidden="true" icon="trash"/></b-button>
          </b-input-group>
          </b-col>
            <b-col sm="6">
          <b-input-group prepend="Market Session Date Start Range:" class="mt-3">
              <rangedate-picker @selected="onDateSelectedStart" class="form-control" righttoleft="true" i18n="EN"></rangedate-picker>
          </b-input-group>
        </b-col>
      </b-row>
     </b-card>

    <!-- Modal Component -->
    <b-modal id="modal1" title="New Market Session" @ok="handleOk" ref="modal">
      <b-form>
        <b-form-group id="exampleInputGroup1" label="Market Type:" label-for="marketType">
          <b-form-select v-model="form.marketType" class="mb-3" id="marketType">
            <option v-for="type in marketTypes" v-bind:key="type.key" :value="type.value">{{type.key}}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group id="exampleInputGroup5" label="Start Date:" label-for="start">
          <datetime type="datetime" id="start" :minute-step="15" v-model="form.start"></datetime>
        </b-form-group>
        <b-form-group id="exampleInputGroup5" label="End Date:" label-for="end">
          <datetime type="datetime" id="end" :minute-step="15" v-model="form.end"></datetime>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-table striped hover :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="results" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="table-romeflex">
      <template #cell(start)="data">
        {{data.item.start | formatDate}}
      </template>
      <template #cell(end)="data">
        {{data.item.end | formatDate}}
      </template>
      <template #cell(marketType)="data">
        {{data.item.marketType}}
      </template>
      <template #cell(status)="data">
        <b-badge v-if="data.item.status==='request'" variant="info">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status==='mip-request'" variant="warning">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status==='stand-by'" variant="dark ">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status==='closed'" variant="secondary">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status==='offer'" variant="primary">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status==='settled'" variant="success">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status==='empty'" variant="warning">{{data.item.status}}</b-badge>
      </template>
      <template #cell()="data">
        <b-button v-b-tooltip.hover title="Details" size="sm" v-on:click="goToFlexibilityServices(data.item._id, data.item.marketType, data.item.startActivation, data.item.status)">Details</b-button>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="results.length"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </b-container>
</template>

<style>
.create-button {
  margin-bottom: 20px;
  background-color: #af0f6a;
}
.input-date {
  width: 100% !important;
  padding: 0 !important;
  border: 0px !important;
}
.calendar-head h2 {
  font-size: 15px !important;
}
.input-group-text {
  color: #fff;
  background-color: #F7931E !important;
}
.page-item.active .page-link {
    background-color: #af0f6a;
    border-color: #af0f6a;
}
.btn-light {
    color: #fff;
    background-color: #f7ac51;
    border-color: #f7ac51;
}
</style>

<script>
import MarketSessionsService from '../services/MarketSessionsService'

export default {
  mounted () {
    this.getMarketSessions()
  },
  data () {
    return {
      filter: null,
      sortBy: 'start',
      sortDesc: true,
      results: [],
      fields: [
        { key: 'start', label: 'Start Date', sortable: true },
        { key: 'end', label: 'End Date', sortable: true },
        { key: 'marketType', label: 'MarketType', sortable: true },
        { key: 'status', label: 'Status' },
        { key: 'action', label: 'Actions' }
      ],
      form: {},
      options: {
        format: 'YYYY-MM-DD hh:mm:ss',
        useCurrent: false
      },
      currentPage: 1,
      perPage: 10,
      marketTypes: [
        { key: 'Day Ahead', value: 'dayAhead' },
        { key: 'Real Time', value: 'realTime' }
      ],
      selectedDateStart: {
        start: new Date(),
        end: new Date()
      }
    }
  },
  methods: {
    async getMarketSessions () {
      const response = await MarketSessionsService.getMarketSessions()
      console.log('Response ' + JSON.stringify(response.data))
      this.results = response.data
    },
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      this.handleSubmit()
    },
    async handleSubmit () {
      await MarketSessionsService.save(this.form)
      await this.getMarketSessions()
      this.$refs.modal.hide()
    },
    goToFlexibilityServices (sessionId, marketType, startActivation, status) {
      this.$router.push({ name: 'FlexibilityServices', params: { sessionId: sessionId, marketType: marketType, startActivation: startActivation, status: status } })
    },
    onDateSelectedStart: function (daterange) {
      this.selectedDateStart = daterange
      console.log(daterange)
      this.fetchMarketSession(daterange)
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async fetchMarketSession (dateRange) {
      const params = {}
      if (dateRange) {
        params.end = dateRange.end
        params.start = dateRange.start
      }
      const response = await MarketSessionsService.getMarketSessions(params)
      console.log('Response Filtered' + JSON.stringify(response.data))
      this.results = response.data
      this.totalRows = this.results.length
    },
    clearAll () {
      this.filter = null
      this.totalRows = this.results.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MarketSessions.vue